<template>
    <div class="tyn-root">
        <Header></Header>

        <div class="tyn-content tyn-content-page">
            <div class="tyn-hero">
                <div class="container">
                    <div class="row justify-content-center text-center">
                        <div class="col-lg-4">
                            <h1 class="display-6">Relatório de Uso</h1>
                            <!--<p>Acompanhe as consultas dos usuários do contrato.</p>-->
                        </div><!-- .col -->
                    </div><!-- .row -->
                </div><!-- .container -->
            </div>
            <div class="tyn-main tyn-modal-preview">
                <div class="tyn-section">
                    <div class="container-xl">
                        <div class="row mb-4 px-4" v-if="qtdUtilizacoes">
                            <!-- TOTAIS -->
                            <div class="col-12 box-cinza my-3 p-2">
                                <div class="row">
                                    <div class="col-12 col-md-3 text-center">
                                        <span>Utilizações no contrato atual</span>

                                        <h3 class="bold" style="font-weight:bold;">{{qtdUtilizacoes}}</h3>
                                    </div>
                                </div>
                            </div>
                        </div>

                        

                        <div class="tyn-section-content">
                            <div class="tabs-header d-flex align-items-center justify-content-center px-3">
                                <ul class="nav nav-tabs my-2 flex-grow-1" role="tablist">
                                    <li class="nav-item" role="presentation">
                                        <button class="nav-link active" data-bs-toggle="tab" data-bs-target="#action-1" type="button">Consultas </button>
                                    </li>
                                    <li class="nav-item" role="presentation">
                                        <button class="nav-link" data-bs-toggle="tab" data-bs-target="#action-2" type="button">Artefatos </button>
                                    </li>
                                    <li class="nav-item" role="presentation">
                                        <button class="nav-link" data-bs-toggle="tab" data-bs-target="#action-3" type="button">Researchs </button>
                                    </li>
                                    <li class="nav-item" role="presentation">
                                        <button class="nav-link" data-bs-toggle="tab" data-bs-target="#action-5" type="button">Processos </button>
                                    </li>
                                </ul>
                            </div>
                            <div class="py-4">
                                <div class="tab-content">
                                    <div class="tab-pane show active" id="action-1" tabindex="0">
                                        <div class="row mb-4 px-4">
                                            <div class="col-12">
                                                <div class="card filter-card">
                                                    <div class="card-body">
                                                        <div class="filter-header">
                                                            <div class="filter-title-wrapper">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="filter-icon" viewBox="0 0 16 16">
                                                                    <path d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5"/>
                                                                </svg>
                                                                <h6 class="filter-title">Filtrar por Período</h6>
                                                            </div>
                                                        </div>
                                                        <div class="filter-content">
                                                            <div class="date-range-wrapper">
                                                                <div class="date-input-group">
                                                                    <label class="date-label">Data Inicial</label>
                                                                    <div class="date-input-container">
                                                                        <button @click="prev" class="date-nav-btn date-nav-prev" type="button" title="Período anterior">
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                                                <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"/>
                                                                            </svg>
                                                                        </button>
                                                                        <date-picker class="date-picker-modern" v-model="dtInicio" valueType="format" format="DD/MM/YYYY" :clearable="false"></date-picker>
                                                                    </div>
                                                                </div>
                                                                <div class="date-separator">
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                                                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m8-7A8 8 0 1 1 0 8a8 8 0 0 1 16 0M4.5 7.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1z"/>
                                                                    </svg>
                                                                </div>
                                                                <div class="date-input-group">
                                                                    <label class="date-label">Data Final</label>
                                                                    <div class="date-input-container">
                                                                        <date-picker class="date-picker-modern" v-model="dtFim" valueType="format" format="DD/MM/YYYY" :clearable="false"></date-picker>
                                                                        <button @click="next" class="date-nav-btn date-nav-next" type="button" title="Próximo período">
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                                                <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"/>
                                                                            </svg>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <button class="btn-filter-modern" @click="filter" type="button">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
                                                                    <path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5z"/>
                                                                </svg>
                                                                <span>Filtrar</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mb-4 px-4">
                                            <div class="col-12">
                                                <div class="card">
                                                    <div class="card-body">
                                                        <div class="d-flex z-99">
                                                            <div class="p-2 w-100 m-auto"><h6 class="title mb-0">Consultas</h6></div>
                                                            <div class="p-2 flex-shrink-1 ">
                                                                <div class="btn-grp">
                                                                    <div :class="'dropdown'">
                                                                        <button type="button" class="btn d-flex justify-content-center align-items-center"
                                                                                data-bs-toggle="dropdown" aria-expanded="false">
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-three-dots-vertical" viewBox="0 0 16 16">
                                                                                <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
                                                                            </svg>
                                                                        </button>
                                                                        <ul class="dropdown-menu">
                                                                            <li>
                                                                                <a class="dropdown-item" href="javascript:void(0)" @click="imprimir('conversas')"><i class="fas fa-print"></i> Imprimir</a>
                                                                                <a class="dropdown-item" href="javascript:void(0)" @click="pdf('conversas')"><i class="fas fa-file-pdf"></i> Pdf</a>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <table class="custom-table bg-white text-gray-900 dark:bg-gray-800 dark:text-gray-100">
                                                            <thead>
                                                                <tr>
                                                                    <th class="text-center select-none relative bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-100" style="white-space: nowrap; width: 1%;">Legislação</th>
                                                                    <th class="text-center select-none relative bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-100" style="white-space: nowrap; width: 1%;">Formato</th>
                                                                    <th scope="col" class="w-30">Pergunta</th>
                                                                    <th class="text-center select-none relative bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-100" style="white-space: nowrap; width: 1%;">Usuário</th>
                                                                    <th class="text-center select-none relative bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-100" style="white-space: nowrap; width: 1%;">Data</th>
                                                                    <!--<th scope="col" v-if="!flImprimir">Ações</th>-->
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <template v-for="(item,index) in lstConversas">
                                                                    <tr :key="index">
                                                                        <td class="center">{{item.nmLegislacao}}</td>
                                                                        <td class="center">{{item.tpPergunta}}</td>
                                                                        <td><span class="reduz-texto-5" style="max-width: 30vw;">{{item.dsPergunta}}</span></td>
                                                                        <td class="center">{{item.usuario}}</td>
                                                                        <td class="center">{{item.dtPergunta}}</td>
                                                                        <!--<td v-if="!flImprimir"><button class="btn"><i class="feather-eye"></i></button></td>-->
                                                                    </tr>
                                                                </template>
                                                                <template v-if="lstConversas && lstConversas.length == 0">
                                                                    <tr>
                                                                        <td class="text-center" scope="row" colspan="100%">Nenhum registro encontrado.</td>
                                                                    </tr>
                                                                </template>
                                                            </tbody>
                                                            <tfoot v-if="lstConversas && lstConversas.length > 0">
                                                                <tr class="text-end">
                                                                    <td colspan="100%">
                                                                        Registros encontrados: {{lstConversas.length}}
                                                                    </td>
                                                                </tr>
                                                            </tfoot>
                                                        </table>
                                                        <!--<div class="d-flex justify-content-end" v-if="lstConversas.length > 0">
                            <span>
                                Registros encontrados: {{lstConversas.length}}
                            </span>
                        </div>-->
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="tab-pane" id="action-2" tabindex="0">
                                        <div class="row mb-4 px-4">
                                            <div class="col-12">
                                                <div class="card filter-card">
                                                    <div class="card-body">
                                                        <div class="filter-header">
                                                            <div class="filter-title-wrapper">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="filter-icon" viewBox="0 0 16 16">
                                                                    <path d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5"/>
                                                                </svg>
                                                                <h6 class="filter-title">Filtrar por Período</h6>
                                                            </div>
                                                        </div>
                                                        <div class="filter-content">
                                                            <div class="date-range-wrapper">
                                                                <div class="date-input-group">
                                                                    <label class="date-label">Data Inicial</label>
                                                                    <div class="date-input-container">
                                                                        <button @click="prev" class="date-nav-btn date-nav-prev" type="button" title="Período anterior">
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                                                <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"/>
                                                                            </svg>
                                                                        </button>
                                                                        <date-picker class="date-picker-modern" v-model="dtInicio" valueType="format" format="DD/MM/YYYY" :clearable="false"></date-picker>
                                                                    </div>
                                                                </div>
                                                                <div class="date-separator">
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                                                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m8-7A8 8 0 1 1 0 8a8 8 0 0 1 16 0M4.5 7.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1z"/>
                                                                    </svg>
                                                                </div>
                                                                <div class="date-input-group">
                                                                    <label class="date-label">Data Final</label>
                                                                    <div class="date-input-container">
                                                                        <date-picker class="date-picker-modern" v-model="dtFim" valueType="format" format="DD/MM/YYYY" :clearable="false"></date-picker>
                                                                        <button @click="next" class="date-nav-btn date-nav-next" type="button" title="Próximo período">
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                                                <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"/>
                                                                            </svg>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <button class="btn-filter-modern" @click="filter" type="button">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
                                                                    <path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5z"/>
                                                                </svg>
                                                                <span>Filtrar</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mb-4 px-4">
                                            <div class="col-12">
                                                <div class="card">
                                                    <div class="card-body">
                                                        <div class="d-flex z-99">
                                                            <div class="p-2 w-100 m-auto"><h6 class="title mb-0">Artefatos</h6></div>
                                                            <div class="p-2 flex-shrink-1 ">
                                                                <div class="btn-grp">
                                                                    <div :class="'dropdown'">
                                                                        <button type="button" class="btn d-flex justify-content-center align-items-center"
                                                                                data-bs-toggle="dropdown" aria-expanded="false">
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-three-dots-vertical" viewBox="0 0 16 16">
                                                                                <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
                                                                            </svg>
                                                                        </button>
                                                                        <ul class="dropdown-menu">
                                                                            <li>
                                                                                <a class="dropdown-item" href="javascript:void(0)" @click="imprimir('artefatos')"><i class="fas fa-print"></i>  Imprimir</a>
                                                                                <a class="dropdown-item" href="javascript:void(0)" @click="pdf('artefatos')"><i class="fas fa-file-pdf"></i> Pdf</a>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <table class="custom-table bg-white text-gray-900 dark:bg-gray-800 dark:text-gray-100">
                                                            <thead>
                                                                <tr>
                                                                    <th class="text-center select-none relative bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-100" style="white-space: nowrap; width: 1%;">Legislação</th>
                                                                    <th class="text-left select-none relative bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-100">Modelo</th>
                                                                    <th class="text-center select-none relative bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-100" style="white-space: nowrap; width: 1%;">Usuário</th>
                                                                    <th class="text-center select-none relative bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-100" style="white-space: nowrap; width: 1%;">Data</th>
                                                                    <!--<th scope="col" v-if="!flImprimir">Ações</th>-->
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <template v-for="(item,index) in lstArtefatos">
                                                                    <tr :key="index">
                                                                        <td class="center">{{item.nmLegislacao}}</td>
                                                                        <td>{{item.nmModelo}}</td>
                                                                        <td class="center">{{item.usuario}}</td>
                                                                        <td class="center">{{item.dtInclusao}}</td>
                                                                        <!--<td v-if="!flImprimir"><button class="btn"><i class="feather-eye"></i></button></td>-->
                                                                    </tr>
                                                                </template>
                                                                <template v-if="lstArtefatos && lstArtefatos.length == 0">
                                                                    <tr>
                                                                        <td class="text-center" scope="row" colspan="100%">Nenhum registro encontrado.</td>
                                                                    </tr>
                                                                </template>
                                                            </tbody>
                                                            <tfoot v-if="lstArtefatos && lstArtefatos.length > 0">
                                                                <tr class="text-end">
                                                                    <td colspan="100%">
                                                                        Registros encontrados: {{lstArtefatos.length}}
                                                                    </td>
                                                                </tr>
                                                            </tfoot>
                                                        </table>
                                                        <!--<div class="d-flex justify-content-end" v-if="lstArtefatos.length > 0">
                            <span>
                                Registros encontrados: {{lstArtefatos.length}}
                            </span>
                        </div>-->

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="tab-pane" id="action-3" tabindex="0">
                                        <div class="row mb-4 px-4">
                                            <div class="col-12">
                                                <div class="card filter-card">
                                                    <div class="card-body">
                                                        <div class="filter-header">
                                                            <div class="filter-title-wrapper">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="filter-icon" viewBox="0 0 16 16">
                                                                    <path d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5"/>
                                                                </svg>
                                                                <h6 class="filter-title">Filtrar por Período</h6>
                                                            </div>
                                                        </div>
                                                        <div class="filter-content">
                                                            <div class="date-range-wrapper">
                                                                <div class="date-input-group">
                                                                    <label class="date-label">Data Inicial</label>
                                                                    <div class="date-input-container">
                                                                        <button @click="prev" class="date-nav-btn date-nav-prev" type="button" title="Período anterior">
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                                                <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"/>
                                                                            </svg>
                                                                        </button>
                                                                        <date-picker class="date-picker-modern" v-model="dtInicio" valueType="format" format="DD/MM/YYYY" :clearable="false"></date-picker>
                                                                    </div>
                                                                </div>
                                                                <div class="date-separator">
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                                                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m8-7A8 8 0 1 1 0 8a8 8 0 0 1 16 0M4.5 7.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1z"/>
                                                                    </svg>
                                                                </div>
                                                                <div class="date-input-group">
                                                                    <label class="date-label">Data Final</label>
                                                                    <div class="date-input-container">
                                                                        <date-picker class="date-picker-modern" v-model="dtFim" valueType="format" format="DD/MM/YYYY" :clearable="false"></date-picker>
                                                                        <button @click="next" class="date-nav-btn date-nav-next" type="button" title="Próximo período">
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                                                <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"/>
                                                                            </svg>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <button class="btn-filter-modern" @click="filter" type="button">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
                                                                    <path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5z"/>
                                                                </svg>
                                                                <span>Filtrar</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mb-4 px-4">
                                            <div class="col-12">
                                                <div class="card">
                                                    <div class="card-body">
                                                        <div class="d-flex z-99">
                                                            <div class="p-2 w-100 m-auto"><h6 class="title mb-0">Researchs</h6></div>
                                                            <div class="p-2 flex-shrink-1 ">
                                                                <div class="btn-grp">
                                                                    <div :class="'dropdown'">
                                                                        <button type="button" class="btn d-flex justify-content-center align-items-center"
                                                                                data-bs-toggle="dropdown" aria-expanded="false">
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-three-dots-vertical" viewBox="0 0 16 16">
                                                                                <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
                                                                            </svg>
                                                                        </button>
                                                                        <ul class="dropdown-menu">
                                                                            <li>
                                                                                <a class="dropdown-item" href="javascript:void(0)" @click="imprimir('researchs')"><i class="fas fa-print"></i>  Imprimir</a>
                                                                                <a class="dropdown-item" href="javascript:void(0)" @click="pdf('researchs')"><i class="fas fa-file-pdf"></i> Pdf</a>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <table class="custom-table bg-white text-gray-900 dark:bg-gray-800 dark:text-gray-100">
                                                            <thead>
                                                                <tr>
                                                                    <th class="text-left select-none relative bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-100">Nome</th>
                                                                    <th class="text-center select-none relative bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-100">Tipo</th>
                                                                    <th class="text-center select-none relative bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-100" style="white-space: nowrap; width: 1%;">Usuário</th>
                                                                    <th class="text-center select-none relative bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-100" style="white-space: nowrap; width: 1%;">Data</th>
                                                                    <!--<th scope="col" v-if="!flImprimir">Ações</th>-->
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <template v-for="(item,index) in lstResearchs">
                                                                    <tr :key="index">
                                                                        <td>{{item.dsNome}}</td>
                                                                        <td class="center">{{item.nmTipoResearch}}</td>
                                                                        <td class="center">{{item.usuario}}</td>
                                                                        <td class="center">{{item.dtInclusao}}</td>
                                                                        <!--<td v-if="!flImprimir"><button class="btn"><i class="feather-eye"></i></button></td>-->
                                                                    </tr>
                                                                </template>
                                                                <template v-if="lstResearchs && lstResearchs.length == 0">
                                                                    <tr>
                                                                        <td class="text-center" scope="row" colspan="100%">Nenhum registro encontrado.</td>
                                                                    </tr>
                                                                </template>
                                                            </tbody>
                                                            <tfoot v-if="lstResearchs && lstResearchs.length > 0">
                                                                <tr class="text-end">
                                                                    <td colspan="100%">
                                                                        Registros encontrados: {{lstResearchs.length}}
                                                                    </td>
                                                                </tr>
                                                            </tfoot>
                                                        </table>
                                                        <!--<div class="d-flex justify-content-end" v-if="lstResearchs.length > 0">
                            <span>
                                Registros encontrados: {{lstResearchs.length}}
                            </span>
                        </div>-->

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="tab-pane" id="action-5" tabindex="0">
                                        <div class="row mb-4 px-4">
                                            <div class="col-12">
                                                <div class="card filter-card">
                                                    <div class="card-body">
                                                        <div class="filter-header">
                                                            <div class="filter-title-wrapper">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="filter-icon" viewBox="0 0 16 16">
                                                                    <path d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5"/>
                                                                </svg>
                                                                <h6 class="filter-title">Filtrar por Período</h6>
                                                            </div>
                                                        </div>
                                                        <div class="filter-content">
                                                            <div class="date-range-wrapper">
                                                                <div class="date-input-group">
                                                                    <label class="date-label">Data Inicial</label>
                                                                    <div class="date-input-container">
                                                                        <button @click="prev" class="date-nav-btn date-nav-prev" type="button" title="Período anterior">
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                                                <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"/>
                                                                            </svg>
                                                                        </button>
                                                                        <date-picker class="date-picker-modern" v-model="dtInicio" valueType="format" format="DD/MM/YYYY" :clearable="false"></date-picker>
                                                                    </div>
                                                                </div>
                                                                <div class="date-separator">
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                                                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m8-7A8 8 0 1 1 0 8a8 8 0 0 1 16 0M4.5 7.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1z"/>
                                                                    </svg>
                                                                </div>
                                                                <div class="date-input-group">
                                                                    <label class="date-label">Data Final</label>
                                                                    <div class="date-input-container">
                                                                        <date-picker class="date-picker-modern" v-model="dtFim" valueType="format" format="DD/MM/YYYY" :clearable="false"></date-picker>
                                                                        <button @click="next" class="date-nav-btn date-nav-next" type="button" title="Próximo período">
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                                                <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"/>
                                                                            </svg>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <button class="btn-filter-modern" @click="filter" type="button">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
                                                                    <path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5z"/>
                                                                </svg>
                                                                <span>Filtrar</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row mb-4 px-4">
                                            <div class="col-12">
                                                <div class="card" id="processos">
                                                    <div class="card-body">
                                                        <div class="d-flex z-99">
                                                            <div class="p-2 w-100 m-auto">
                                                                <h6 class="title mb-0">Processos</h6>
                                                            </div>
                                                            <div class="p-2 flex-shrink-1 ">
                                                                <div class="btn-grp">
                                                                    <div :class="'dropdown'">
                                                                        <button type="button" class="btn d-flex justify-content-center align-items-center"
                                                                                data-bs-toggle="dropdown" aria-expanded="false">
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-three-dots-vertical" viewBox="0 0 16 16">
                                                                                <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
                                                                            </svg>
                                                                        </button>
                                                                        <ul class="dropdown-menu">
                                                                            <li>
                                                                                <a class="dropdown-item" href="javascript:void(0)" @click="imprimir('processos')"><i class="fas fa-print"></i>  Imprimir</a>
                                                                                <a class="dropdown-item" href="javascript:void(0)" @click="pdf('processos')"><i class="fas fa-file-pdf"></i> Pdf</a>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <table class="custom-table bg-white text-gray-900 dark:bg-gray-800 dark:text-gray-100">
                                                            <thead>
                                                                <tr>
                                                                    <th class="text-left select-none relative bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-100">
                                                                        Nome
                                                                    </th>
                                                                    <th class="text-center select-none relative bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-100" style="white-space: nowrap; width: 1%;">
                                                                        Número
                                                                    </th>
                                                                    <th class="text-center select-none relative bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-100" style="white-space: nowrap; width: 1%;">
                                                                        Usuário
                                                                    </th>
                                                                    <th class="text-center select-none relative bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-100" style="white-space: nowrap; width: 1%;">
                                                                        Data
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <template v-for="(item,index) in lstProcessos">
                                                                    <tr :key="index">
                                                                        <td>{{ item.processo.dsNome }}</td>
                                                                        <td class="center">{{ item.processo.nrProcesso }}</td>
                                                                        <td class="center">{{ item.proprietario.nmUsuario }}</td>
                                                                        <td class="center">{{ item.processo.dtInclusao }}</td>
                                                                    </tr>
                                                                </template>
                                                                <template v-if="lstProcessos && lstProcessos.length == 0">
                                                                    <tr>
                                                                        <td class="text-center" scope="row" colspan="100%">Nenhum registro encontrado.</td>
                                                                    </tr>
                                                                </template>
                                                            </tbody>
                                                            <tfoot v-if="lstProcessos && lstProcessos.length > 0">
                                                                <tr class="text-end">
                                                                    <td colspan="100%">
                                                                        Registros encontrados: {{ lstProcessos.length }}
                                                                    </td>
                                                                </tr>
                                                            </tfoot>
                                                        </table>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div><!-- py-4 -->
                        </div><!-- .tyn-section-content -->
                    </div><!-- .container -->
                </div><!-- .tyn-section -->
            </div><!-- .tyn-main -->

        </div><!-- .tyn-content -->
        <div class="tyn-footer border-top">
            <div class="bg-white text-center py-3">
                <p class="mb-0 small">
                    &copy; 2025 <a style="color: unset" target="_blank" href="https://negociospublicos.com.br/">Grupo Negócios Públicos</a>.
                </p>
            </div>
        </div><!-- .tyn-footer -->
        <!-- MODAIS HEADER -->
        <Modais></Modais>

    </div><!-- .tyn-root -->
</template>

<script>
    import Header from '@/components/Header'
    import Modais from '@/components/Modais'

    import { urlApi, avisoErro, avisoToast } from '@/config/global'
    import axios from 'axios'
    import moment from 'moment'
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';
    import 'vue2-datepicker/locale/pt-br';


    export default {
        name: 'RelatorioUso',
        components: { DatePicker, Header, Modais },
        props: {
        },
        computed: {
            isAdmContrato() {
                return this.$store.state.isAdmContrato
            },
            user() {
                return this.$store.state.user
            },
        },
        data: function () {
            return {
                qtdUtilizacoes: null,
                lstLegislacao: [],
                lstConversas: null,
                lstArtefatos: null,
                lstResearchs: null,
                dtInicio: moment().add(-7, 'days').format('DD/MM/YYYY'),
                dtFim: moment().format('DD/MM/YYYY'),

                dtInicioFiltro: null,
                dtFimFiltro: null,

                options: {
                    placeholder: '__/__/____',
                },

                flImprimir: false,
                time1: null,
                lstProcessos: [],
            }
        },
        methods: {
            load() {
                this.dtInicioFiltro = moment(this.dtInicio, 'DD/MM/YYYY').format("YYYY-MM-DD");
                this.dtFimFiltro = moment(this.dtFim, 'DD/MM/YYYY').format("YYYY-MM-DD");
                this.getLegislacaoes();

                
            },

            filter() {
                axios.post(`${urlApi}/Log/Registrar`, { cdTipoLog: 'ADM_CON_REL_USO' }).catch(() => { })

                this.dtInicioFiltro = moment(this.dtInicio, 'DD/MM/YYYY').format("YYYY-MM-DD");
                this.dtFimFiltro = moment(this.dtFim, 'DD/MM/YYYY').format("YYYY-MM-DD");
                this.getConversas();
                this.getArtefatos();
                this.getResearchs();
                this.getProcessos();
            },

            getLegislacaoes() {
                let $this = this;
                axios.get(`${urlApi}/Legislacao/Get`, { showLoading: false, params: {} })
                    .then(res => {
                        if (res.data.success) {
                            $this.lstLegislacao = [];
                            for (let i = 0; i < res.data.data.length; i++) {
                                var item = res.data.data[i];

                                $this.lstLegislacao.push({ value: item.idLegislacao, titulo: item.dsNome, descricao: item.dsLegislacao });
                            }
                            this.getConversas();
                            this.getArtefatos();
                            this.getResearchs();
                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro(res.response.statusText);
                        }
                        $this.loading.hide();
                    });
            },

            getConversas() {
                let $this = this;
                axios.get(`${urlApi}/Parecer/Get`, {
                    showLoading: true,
                    params: {
                        dtInicio: $this.dtInicioFiltro + " 00:00:00",
                        dtFim: $this.dtFimFiltro + " 23:59:59"
                    }
                })
                    .then(res => {
                        if (res.data.success) {
                            $this.lstConversas = [];
                            const resultado = res.data.data.resultados;

                            for (let i = 0; i < resultado.rows.length; i++) {
                                var item = resultado.rows[i];

                                var nmLegislacao, status, dtAtualizacao = '';
                                if (item.lstConversaMovimento.length > 0) {
                                    let ultimoMovimento = item.lstConversaMovimento[item.lstConversaMovimento.length - 1];
                                    status = ultimoMovimento.dsMovimento;
                                    dtAtualizacao = moment(ultimoMovimento.dtInclusao).format('DD/MM/YYYY [às] HH:mm');
                                }

                                if ($this.lstLegislacao.length > 0) {
                                    let legislacao = $this.lstLegislacao.find(x => x.value == item.conversa.idLegislacao);
                                    if (legislacao) {
                                        nmLegislacao = legislacao.titulo;
                                    }
                                }

                                var pergunta = {
                                    idConversa: item.conversa.idConversa,
                                    dsPergunta: item.conversa.dsPergunta,
                                    dsResposta: item.conversa.dsResposta,
                                    tpPergunta: (item.conversa.tpPergunta == "RO" || item.conversa.tpPergunta == "Resposta Objetiva"
                                        ? "Resposta Objetiva"
                                        : "Parecer Técnico"),
                                    usuario: item.usuario.nmUsuario,
                                    dtPergunta: moment(item.conversa.dtInclusao).format('DD/MM/YYYY [às] HH:mm'),
                                    status: status,
                                    dtAtualizacao: dtAtualizacao,
                                    nmLegislacao: nmLegislacao,
                                };

                                $this.lstConversas.push(pergunta);
                            }
                        } else {
                            avisoErro("Não foi possível carregar suas perguntas.");
                        }
                    })
                    .catch(res => {
                        if (res.data !== undefined) {
                            avisoErro(res.data);
                        } else {
                            avisoErro("Não foi possível carregar suas perguntas.");
                        }
                    });
            },

            getArtefatos() {
                let $this = this;
                axios.get(`${urlApi}/Artefato/Get`, { showLoading: true, params: { dtInicio: $this.dtInicioFiltro + " 00:00:00", dtFim: $this.dtFimFiltro + " 23:59:59" } })
                    .then(res => {
                        if (res.data.success) {
                            $this.lstArtefatos = [];
                            const resultado = res.data.data.resultados;
                            for (let i = 0; i < resultado.rows.length; i++) {
                                var item = resultado.rows[i];

                                var status = '';
                                if (item.lstArtefatoMovimento.length > 0) {
                                    status = item.lstArtefatoMovimento[item.lstArtefatoMovimento.length - 1].dsMovimento;
                                }

                                var artefato = {
                                    idArtefato: item.artefato.idArtefato,
                                    dsLogin: item.artefato.dsLogin,
                                    usuario: item.usuario.nmUsuario,
                                    dsNome: item.artefato.dsNome,
                                    dtInclusao: moment(item.artefato.dtInclusao).format('DD/MM/YYYY [às] HH:mm'),
                                    nmModelo: item.modeloArtefato.nmModelo,
                                    status: status,
                                    nmLegislacao: (item.modeloArtefato.idLegislacaoModeloArtefato == 1 ? "14.133" : "13.303"),
                                };
                                $this.lstArtefatos.push(artefato);
                            }
                        } else {
                            avisoErro("Não foi possível carregar seus artefatos.");
                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.data);
                        } else {
                            avisoErro("Não foi possível carregar seus artefatos.");
                        }
                    });
            },

            getResearchs() {
                let $this = this;
                axios.get(`${urlApi}/Research/Get`, { showLoading: true, params: { dtInicio: $this.dtInicioFiltro + " 00:00:00", dtFim: $this.dtFimFiltro + " 23:59:59" } })
                    .then(res => {
                        if (res.data.success) {
                            $this.lstResearchs = [];
                            const resultado = res.data.data.resultados;
                            for (let i = 0; i < resultado.rows.length; i++) {
                                var item = resultado.rows[i];

                                var status = '';
                                if (item.lstResearchMovimento.length > 0) {
                                    status = item.lstResearchMovimento[item.lstResearchMovimento.length - 1].dsMovimento;
                                }

                                var research = {
                                    idResearch: item.research.idResearch,
                                    dsLogin: item.research.dsLogin,
                                    usuario: item.usuario.nmUsuario,
                                    dsNome: item.research.dsNome,
                                    dtInclusao: moment(item.research.dtInclusao).format('DD/MM/YYYY [às] HH:mm'),
                                    nmTipoResearch: item.tipoResearch.dsNome,
                                    status: status,
                                };
                                $this.lstResearchs.push(research);
                            }
                        } else {
                            avisoErro("Não foi possível carregar seus researchs.");
                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.data);
                        } else {
                            avisoErro("Não foi possível carregar seus researchs.");
                        }
                    });
            },

            getProcessos() {
                let $this = this;
                axios.get(`${urlApi}/Processo/Get`, {
                    params: {
                        dtInicio: $this.dtInicioFiltro + " 00:00:00",
                        dtFim: $this.dtFimFiltro + " 23:59:59"
                    }
                })
                    .then(res => {
                        if (res.data.success) {
                            const result = res.data.data;

                            $this.lstProcessos = result.resultados.rows.map(p => {
                                return {
                                    ...p,
                                    processo: {
                                        ...p.processo,
                                        dtInclusao: p.processo.dtInclusao
                                            ? moment(p.processo.dtInclusao).format('DD/MM/YYYY [às] HH:mm')
                                            : ''
                                    }
                                };
                            });
                        } else {
                            console.warn("Resposta sem sucesso");
                        }
                    })
                    .catch(err => {
                        console.error("Erro ao fazer requisição:", err);
                        avisoToast("Erro ao carregar processos!", "warning");
                    });
            },

            imprimir(id) {
                let $this = this;
                $this.flImprimir = true;
                // Pass the element id here
                $this.$nextTick(function () {
                    $this.print(id);
                })
            },

            prev() {
                this.dtFim = moment(this.dtInicio, "DD/MM/YYYY").format('DD/MM/YYYY');
                this.dtInicio = moment(this.dtFim, "DD/MM/YYYY").add(-7, 'days').format('DD/MM/YYYY');
            },

            next() {
                if (moment(this.dtFim, "DD/MM/YYYY") < moment(moment().format("DD/MM/YYYY"), "DD/MM/YYYY")) {
                    this.dtInicio = moment(this.dtFim, "DD/MM/YYYY").format('DD/MM/YYYY');
                    this.dtFim = moment(this.dtFim, "DD/MM/YYYY").add(7, 'days').format('DD/MM/YYYY');
                }
            },

            async print(id) {
                let $this = this;
                await $this.$htmlToPaper(id, {
                    styles: [
                        'assets/css/style.css',
                        'assets/css/stylePrintRelatorioUso.css',
                        'https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css',
                        //'assets/css/plugins/bootstrap.min.css',
                        //'assets/css/plugins/animation.css',
                        //'assets/css/plugins/feature.css',
                        //'assets/css/plugins/magnify.min.css',
                        //'assets/css/plugins/slick.css',
                        //'assets/css/plugins/slick-theme.css',
                        //'assets/css/plugins/lightbox.css',
                        //'assets/css/plugins/bootstrap-select.min.css',
                        //'assets/css/plugins/material-icons/css/materialicons.css',
                        //'assets/css/plugins/prism.css',
                    ],
                    "name": "_blank",
                    "windowTitle": "Utilizações SollAi"
                }, () => {
                    $this.flImprimir = false;
                });
            },

            pdf(id) {
                let $this = this;
                let url = "";

                switch (id) {
                    case "conversas":
                        url = "ListagemConversas";
                        break;
                    case "artefatos":
                        url = "ListagemArtefatos";
                        break;
                    case "researchs":
                        url = "ListagemResearchs";
                        break;
                    case "processos":
                        url = "ListagemProcessos";
                        break;
                }
                
                axios({
                    url: `${urlApi}/Relatorio/${url}`,
                    method: 'GET',
                    responseType: 'blob',
                    params: { dtInicio: $this.dtInicioFiltro + " 00:00:00", dtFim: $this.dtFimFiltro + " 23:59:59" }
                })
                    .then(response => {
                        // create file link in browser's memory
                        const href = URL.createObjectURL(response.data);

                        // create "a" HTML element with href to file & click
                        const link = document.createElement('a');
                        link.href = href;
                        link.setAttribute('download', 'documento.pdf'); //or any other extension
                        document.body.appendChild(link);
                        link.click();

                        // clean up "a" element & remove ObjectURL
                        document.body.removeChild(link);
                        URL.revokeObjectURL(href);
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro(res.response.statusText);
                        }
                    });
            },

        },


        mounted: function () {
            if (this.isAdmContrato != 'Sim' && this.user.usuario.idContrato != 0 && !this.user?.usuarioApi?.flAdministrador) {
                this.$router.push({ name: 'Home' });
            }
            this.load();

            //window.$(".popup-dashboardright-section").addClass("collapsed");
            //window.$(".rbt-main-content").addClass("area-right-expanded");
            //window.$(".rbt-static-bar").addClass("area-right-expanded");
        },
        watch: {
            dtInicio: function () {
                if (this.dtInicio == "" || this.dtInicio == null || this.dtInicio == undefined) {
                    this.dtInicio = moment().add(-7, 'days').format('DD/MM/YYYY');
                }
            },
            dtFim: function () {
                if (this.dtFim == "" || this.dtFim == null || this.dtFim == undefined) {
                    this.dtFim = moment().format('DD/MM/YYYY');
                }
            }
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .table-container {
        display: flex;
        justify-content: center;
        padding-top: 32px;
        padding-bottom: 0px;
        padding-left: 16px;
        padding-right: 16px;
    }


    .table-wrapper {
        width: 100%;
        padding: 0 10px;
        margin: 0 auto;
        overflow-x: auto;
    }

    .custom-table {
        width: 100%;
        border: 1px solid rgba(148, 163, 184, 0.2);
        border-radius: 16px;
        box-shadow: 0 4px 12px rgba(15, 23, 42, 0.08), 0 1px 3px rgba(0, 0, 0, 0.05);
        border-collapse: separate;
        border-spacing: 0;
        overflow: hidden;
        background: #ffffff;
    }

    .custom-table thead {
        background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    }

    .custom-table th {
        padding: 1rem 1.25rem;
        font-weight: 600;
        font-family: 'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif;
        font-size: 0.875rem;
        text-transform: uppercase;
        letter-spacing: 0.05em;
        color: #475569;
        border-bottom: 2px solid rgba(148, 163, 184, 0.2);
        background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
        position: relative;
    }

    .custom-table th:first-child {
        border-top-left-radius: 16px;
    }

    .custom-table th:last-child {
        border-top-right-radius: 16px;
    }

    .custom-table tbody tr {
        transition: all 0.2s ease;
        border-bottom: 1px solid rgba(148, 163, 184, 0.1);
    }

    .custom-table tbody tr:last-child {
        border-bottom: none;
    }

    .custom-table tbody tr:hover {
        background: linear-gradient(135deg, rgba(37, 99, 235, 0.04) 0%, rgba(59, 130, 246, 0.02) 100%);
        transform: scale(1.001);
        box-shadow: 0 2px 8px rgba(37, 99, 235, 0.08);
    }

    .custom-table td {
        padding: 1rem 1.25rem;
        font-family: 'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif;
        font-size: 0.9375rem;
        color: #1e293b;
        vertical-align: middle;
        border-bottom: 1px solid rgba(148, 163, 184, 0.1);
    }

    .custom-table tbody tr:last-child td:first-child {
        border-bottom-left-radius: 16px;
    }

    .custom-table tbody tr:last-child td:last-child {
        border-bottom-right-radius: 16px;
    }

    .custom-table tfoot {
        background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    }

    .custom-table tfoot tr {
        border-top: 2px solid rgba(148, 163, 184, 0.2);
    }

    .custom-table tfoot td {
        padding: 1rem 1.25rem;
        font-weight: 600;
        font-size: 0.875rem;
        color: #475569;
        background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    }

    .custom-table tfoot tr:last-child td:first-child {
        border-bottom-left-radius: 16px;
    }

    .custom-table tfoot tr:last-child td:last-child {
        border-bottom-right-radius: 16px;
    }

    .custom-table-footer {
        border: 1px solid rgba(148, 163, 184, 0.2);
        border-top: none;
        border-radius: 0 0 16px 16px;
        padding: 1rem 1.25rem;
        display: flex;
        justify-content: space-between;
        font-family: 'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif;
        align-items: center;
        font-weight: 600;
        font-size: 0.875rem;
        color: #475569;
        background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
        box-shadow: 0 -2px 8px rgba(15, 23, 42, 0.05);
    }

    .pagination-controls {
        display: flex;
    }

    .custom-table-header {
        background-color: white;
        border: 1px solid #e5e7eb;
        border-bottom: none;
        border-radius: 8px 8px 0 0;
        padding: 12px 16px;
        display: flex;
        align-items: center;
        gap: 16px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    }

    .page-box {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 36px;
        height: 36px;
        border: 1px solid #d1d5db;
        border-radius: 6px;
        line-height: 1;
        transform: translateY(-1px);
        font-weight: 600;
        font-size: 14px;
        cursor: pointer;
        transition: all 0.2s ease-in-out;
    }
    /* Mensagem de tabela vazia */
    .custom-table tbody tr td[colspan] {
        text-align: center;
        padding: 3rem 1.25rem;
        color: #64748b;
        font-style: italic;
        background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
    }

    /* Suporte para tema escuro - Tabelas */
    [data-bs-theme="dark"] .custom-table {
        background: linear-gradient(135deg, rgba(15, 23, 42, 0.95) 0%, rgba(30, 41, 59, 0.9) 100%);
        border-color: rgba(59, 130, 246, 0.3);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3), 0 1px 3px rgba(0, 0, 0, 0.2);
    }

    [data-bs-theme="dark"] .custom-table thead {
        background: linear-gradient(135deg, rgba(30, 41, 59, 0.95) 0%, rgba(51, 65, 85, 0.9) 100%);
    }

    [data-bs-theme="dark"] .custom-table th {
        color: #cbd5e1;
        border-bottom-color: rgba(59, 130, 246, 0.3);
        background: linear-gradient(135deg, rgba(30, 41, 59, 0.95) 0%, rgba(51, 65, 85, 0.9) 100%);
    }

    [data-bs-theme="dark"] .custom-table tbody tr {
        border-bottom-color: rgba(59, 130, 246, 0.15);
    }

    [data-bs-theme="dark"] .custom-table tbody tr:hover {
        background: linear-gradient(135deg, rgba(59, 130, 246, 0.12) 0%, rgba(37, 99, 235, 0.08) 100%);
        box-shadow: 0 2px 8px rgba(59, 130, 246, 0.2);
    }

    [data-bs-theme="dark"] .custom-table td {
        color: #e2e8f0;
        border-bottom-color: rgba(59, 130, 246, 0.15);
    }

    [data-bs-theme="dark"] .custom-table tfoot {
        background: linear-gradient(135deg, rgba(30, 41, 59, 0.95) 0%, rgba(51, 65, 85, 0.9) 100%);
    }

    [data-bs-theme="dark"] .custom-table tfoot tr {
        border-top-color: rgba(59, 130, 246, 0.3);
    }

    [data-bs-theme="dark"] .custom-table tfoot td {
        color: #cbd5e1;
        background: linear-gradient(135deg, rgba(30, 41, 59, 0.95) 0%, rgba(51, 65, 85, 0.9) 100%);
    }

    [data-bs-theme="dark"] .custom-table tbody tr td[colspan] {
        color: #94a3b8;
        background: linear-gradient(135deg, rgba(15, 23, 42, 0.95) 0%, rgba(30, 41, 59, 0.9) 100%);
    }

    [data-bs-theme="dark"] .custom-table-footer {
        background: linear-gradient(135deg, rgba(30, 41, 59, 0.95) 0%, rgba(51, 65, 85, 0.9) 100%);
        border-color: rgba(59, 130, 246, 0.3);
        color: #cbd5e1;
        box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.3);
    }

    /* Sobrescrever classes inline do HTML */
    .custom-table th.bg-gray-100,
    .custom-table th.bg-gray-700 {
        background: transparent !important;
    }

    .custom-table th.text-gray-800,
    .custom-table th.text-gray-100 {
        color: inherit !important;
    }

    .custom-table.bg-white,
    .custom-table.text-gray-900 {
        background: #ffffff !important;
        color: inherit !important;
    }

    [data-bs-theme="dark"] .custom-table.bg-white,
    [data-bs-theme="dark"] .custom-table.dark\:bg-gray-800 {
        background: linear-gradient(135deg, rgba(15, 23, 42, 0.95) 0%, rgba(30, 41, 59, 0.9) 100%) !important;
    }

    [data-bs-theme="dark"] .custom-table.text-gray-900,
    [data-bs-theme="dark"] .custom-table.dark\:text-gray-100 {
        color: inherit !important;
    }

    /* Estilo para células centralizadas */
    .custom-table td.center,
    .custom-table th.text-center {
        text-align: center;
    }

    /* Estilo para texto reduzido */
    .reduz-texto-1 {
        display: inline-block;
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    /* Scrollbar personalizada para tabelas com overflow */
    .table-wrapper::-webkit-scrollbar {
        height: 8px;
    }

    .table-wrapper::-webkit-scrollbar-track {
        background: #f1f5f9;
        border-radius: 10px;
    }

    .table-wrapper::-webkit-scrollbar-thumb {
        background: linear-gradient(135deg, #2563eb 0%, #22c55e 100%);
        border-radius: 10px;
    }

    .table-wrapper::-webkit-scrollbar-thumb:hover {
        background: linear-gradient(135deg, #1d4ed8 0%, #16a34a 100%);
    }

    [data-bs-theme="dark"] .table-wrapper::-webkit-scrollbar-track {
        background: rgba(30, 41, 59, 0.8);
    }

    [data-bs-theme="dark"] .table-wrapper::-webkit-scrollbar-thumb {
        background: linear-gradient(135deg, #1d4ed8 0%, #10b981 100%);
    }

    [data-bs-theme="dark"] .table-wrapper::-webkit-scrollbar-thumb:hover {
        background: linear-gradient(135deg, #1e40af 0%, #059669 100%);
    }

    .z-99 {
        z-index: 99;
    }

    .btn-filtrar {
        border-color: #ccc !important;
    }

    .filter-data {
        border: 1px solid #ccc;
    }


    [data-bs-theme=light] .table > :not(caption) > * > * {
        background-color: #FFF; // Choose your own color here
    }
    [data-bs-theme=light] .table-striped > tbody > tr:nth-child(odd) > td,
    [data-bs-theme=light] .table-striped > tbody > tr:nth-child(odd) > th {
        background-color: #FFF; // Choose your own color here
    }

    [data-bs-theme=light] .table-striped > tbody > tr:nth-child(even) > td,
    [data-bs-theme=light] .table-striped > tbody > tr:nth-child(even) > th {
        background-color: #FFF; // Choose your own color here
    }

    [data-bs-theme=light] .table th, .table td {
        font-size: 14px;
    }

    [data-bs-theme=light] .table-striped > tbody > tr:nth-child(odd) > td,
    [data-bs-theme=light] .table-striped > tbody > tr:nth-child(odd) > th {
        background-color: #fefefe; // Choose your own color here
    }

    .center {
        text-align: center;
        vertical-align: middle;
    }

    .tabs-header {
        position: sticky;
        top: 0;
        z-index: 20;
        padding: 0.85rem 1.5rem 0.65rem;
        backdrop-filter: blur(8px);
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 1rem;
        flex-wrap: wrap;
    }

    .nav-tabs {
        border-bottom: none;
        display: flex;
        flex-wrap: wrap;
        gap: 0.5rem;
        margin: 0;
        padding: 0;
        flex-grow: 1;
        justify-content: center;
    }

    .nav-tabs .nav-link {
        border: 1px solid transparent;
        background: rgba(248, 250, 252, 0.75);
        color: #475569;
        font-weight: 600;
        padding: 0.55rem 1.2rem;
        border-radius: 999px;
        display: inline-flex;
        align-items: center;
        gap: 0.45rem;
        transition: all 0.2s ease;
        box-shadow: inset 0 0 0 1px rgba(226, 232, 240, 0.8);
    }

    .nav-tabs .nav-link:hover {
        background: rgba(37, 99, 235, 0.12);
        color: #1d4ed8;
        box-shadow: inset 0 0 0 1px rgba(37, 99, 235, 0.25);
    }

    .nav-tabs .nav-link.active {
        background: linear-gradient(135deg, #2563EB 0%, #22c55e 100%);
        color: #fff;
        box-shadow: 0 12px 26px rgba(37, 99, 235, 0.28);
        border-color: transparent;
    }

    [data-bs-theme="dark"] .tabs-header {
        background: linear-gradient(135deg, rgba(15, 23, 42, 0.95) 0%, rgba(30, 41, 59, 0.95) 100%);
        border-bottom: 1px solid rgba(51, 65, 85, 0.8);
    }

    [data-bs-theme="dark"] .nav-tabs {
        border-bottom: none;
    }

    [data-bs-theme="dark"] .nav-tabs .nav-link {
        background: rgba(30, 41, 59, 0.85);
        color: #cbd5f5;
        box-shadow: inset 0 0 0 1px rgba(51, 65, 85, 0.8);
        border-color: transparent;
    }

    [data-bs-theme="dark"] .nav-tabs .nav-link:hover {
        background: rgba(59, 130, 246, 0.25);
        color: #93c5fd;
        box-shadow: inset 0 0 0 1px rgba(59, 130, 246, 0.4);
    }

    [data-bs-theme="dark"] .nav-tabs .nav-link.active {
        background: linear-gradient(135deg, #1d4ed8 0%, #10b981 100%);
        color: #f8fafc;
        box-shadow: 0 14px 32px rgba(15, 118, 110, 0.35);
    }

    /* Estilos modernos para cards */
    .card {
        border: 1px solid rgba(148, 163, 184, 0.2);
        border-radius: 16px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.1);
        background: #ffffff;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        overflow: hidden;
        position: relative;
    }

    .card::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: radial-gradient(circle at top left, rgba(59, 130, 246, 0.04), transparent 60%);
        opacity: 0;
        transition: opacity 0.5s cubic-bezier(0.4, 0, 0.2, 1);
        pointer-events: none;
    }

    .card:hover {
        transform: translateY(-2px);
        box-shadow: 0 10px 25px rgba(15, 23, 42, 0.1), 
                    0 4px 12px rgba(0, 0, 0, 0.08),
                    0 2px 4px rgba(0, 0, 0, 0.06);
        border-color: rgba(148, 163, 184, 0.3);
    }

    .card:hover::before {
        opacity: 1;
    }

    .card-body {
        padding: 1.5rem;
        position: relative;
        z-index: 1;
    }

    .card .title {
        font-weight: 600;
        font-size: 1.125rem;
        color: #1e293b;
        letter-spacing: -0.01em;
        margin-bottom: 1rem;
    }

    .card .title.mb-0 {
        margin-bottom: 0;
    }

    /* Box cinza modernizado */
    .box-cinza {
        background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
        border: 1px solid rgba(148, 163, 184, 0.2);
        border-radius: 16px;
        box-shadow: 0 4px 12px rgba(15, 23, 42, 0.08);
        padding: 1.5rem;
        transition: all 0.3s ease;
    }

    .box-cinza:hover {
        box-shadow: 0 8px 20px rgba(15, 23, 42, 0.12);
        transform: translateY(-1px);
    }

    .box-cinza h3 {
        font-weight: 700;
        color: #0f172a;
        font-size: 1.75rem;
        margin-top: 0.5rem;
    }

    .box-cinza span {
        font-size: 0.95rem;
        color: #64748b;
        font-weight: 500;
    }

    /* Botão filtrar modernizado */
    .btn-filtrar {
        border-radius: 999px;
        padding: 0.65rem 1.5rem;
        font-weight: 600;
        transition: all 0.2s ease;
        border: 1px solid rgba(148, 163, 184, 0.4);
        background: rgba(248, 250, 252, 0.75);
        color: #475569;
    }

    .btn-filtrar:hover {
        background: rgba(37, 99, 235, 0.12);
        color: #1d4ed8;
        border-color: rgba(37, 99, 235, 0.25);
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(37, 99, 235, 0.15);
    }

    /* Dropdown modernizado */
    .btn-grp .dropdown .btn {
        border-radius: 12px;
        padding: 0.5rem;
        border: 1px solid rgba(148, 163, 184, 0.3);
        background: rgba(248, 250, 252, 0.75);
        transition: all 0.2s ease;
    }

    .btn-grp .dropdown .btn:hover {
        background: rgba(37, 99, 235, 0.12);
        border-color: rgba(37, 99, 235, 0.25);
        transform: scale(1.05);
    }

    .dropdown-menu {
        border-radius: 12px;
        border: 1px solid rgba(148, 163, 184, 0.2);
        box-shadow: 0 10px 40px rgba(0, 0, 0, 0.12), 0 4px 12px rgba(0, 0, 0, 0.08);
        padding: 0.5rem;
        margin-top: 0.5rem;
    }

    .dropdown-item {
        border-radius: 8px;
        padding: 0.625rem 0.75rem;
        margin: 0.125rem 0;
        transition: all 0.2s ease;
        display: flex;
        align-items: center;
        gap: 0.5rem;
    }

    .dropdown-item:hover {
        background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
        transform: translateX(4px);
    }

    .dropdown-item i {
        width: 16px;
        text-align: center;
    }

    /* Suporte para tema escuro */
    [data-bs-theme="dark"] .card {
        background: linear-gradient(135deg, rgba(15, 23, 42, 0.95) 0%, rgba(30, 41, 59, 0.9) 100%);
        border-color: rgba(59, 130, 246, 0.3);
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3), 0 1px 2px rgba(0, 0, 0, 0.2);
    }

    [data-bs-theme="dark"] .card:hover {
        box-shadow: 0 10px 25px rgba(0, 0, 0, 0.5), 
                    0 4px 12px rgba(0, 0, 0, 0.4),
                    0 2px 4px rgba(0, 0, 0, 0.3);
        border-color: rgba(59, 130, 246, 0.5);
    }

    [data-bs-theme="dark"] .card::before {
        background: radial-gradient(circle at top left, rgba(59, 130, 246, 0.1), transparent 60%);
    }

    [data-bs-theme="dark"] .card .title {
        color: #f1f5f9;
    }

    [data-bs-theme="dark"] .box-cinza {
        background: linear-gradient(135deg, rgba(15, 23, 42, 0.95) 0%, rgba(30, 41, 59, 0.9) 100%);
        border-color: rgba(59, 130, 246, 0.3);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
    }

    [data-bs-theme="dark"] .box-cinza h3 {
        color: #f1f5f9;
    }

    [data-bs-theme="dark"] .box-cinza span {
        color: #cbd5e1;
    }

    [data-bs-theme="dark"] .btn-filtrar {
        background: rgba(30, 41, 59, 0.85);
        color: #cbd5f5;
        border-color: rgba(51, 65, 85, 0.8);
    }

    [data-bs-theme="dark"] .btn-filtrar:hover {
        background: rgba(59, 130, 246, 0.25);
        color: #93c5fd;
        border-color: rgba(59, 130, 246, 0.4);
    }

    [data-bs-theme="dark"] .btn-grp .dropdown .btn {
        background: rgba(30, 41, 59, 0.85);
        border-color: rgba(51, 65, 85, 0.8);
    }

    [data-bs-theme="dark"] .btn-grp .dropdown .btn:hover {
        background: rgba(59, 130, 246, 0.25);
        border-color: rgba(59, 130, 246, 0.4);
    }

    [data-bs-theme="dark"] .dropdown-menu {
        background: #1e293b;
        border-color: #334155;
        box-shadow: 0 10px 40px rgba(0, 0, 0, 0.4), 0 4px 12px rgba(0, 0, 0, 0.3);
    }

    [data-bs-theme="dark"] .dropdown-item {
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .dropdown-item:hover {
        background: linear-gradient(135deg, #1e3a8a 0%, #1e40af 100%);
        color: #f8fafc;
    }

    /* Ajustes para inputs e date pickers dentro dos cards */
    .card .mx-datepicker {
        border-radius: 999px;
    }

    .card .c-pointer {
        transition: all 0.2s ease;
        border-radius: 50%;
        width: 32px;
        height: 32px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
    }

    .card .c-pointer:hover {
        background: rgba(37, 99, 235, 0.12);
        color: #1d4ed8;
        transform: scale(1.1);
    }

    [data-bs-theme="dark"] .card .c-pointer:hover {
        background: rgba(59, 130, 246, 0.25);
        color: #93c5fd;
    }

    /* Estilos modernos para o card de filtragem */
    .filter-card {
        background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
    }

    .filter-header {
        margin-bottom: 1.5rem;
        padding-bottom: 1rem;
        border-bottom: 1px solid rgba(148, 163, 184, 0.15);
    }

    .filter-title-wrapper {
        display: flex;
        align-items: center;
        gap: 0.75rem;
    }

    .filter-icon {
        color: #2563eb;
        flex-shrink: 0;
    }

    .filter-title {
        font-weight: 600;
        font-size: 1.125rem;
        color: #1e293b;
        letter-spacing: -0.01em;
        margin: 0;
    }

    .filter-content {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-end;
        gap: 1.5rem;
    }

    .date-range-wrapper {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-end;
        gap: 1rem;
        flex: 1;
        min-width: 300px;
    }

    .date-input-group {
        flex: 1;
        min-width: 200px;
    }

    .date-label {
        display: block;
        font-size: 0.875rem;
        font-weight: 600;
        color: #475569;
        margin-bottom: 0.5rem;
        letter-spacing: 0.01em;
    }

    .date-input-container {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        background: #ffffff;
        border: 1px solid rgba(148, 163, 184, 0.3);
        border-radius: 12px;
        padding: 0.25rem;
        transition: all 0.2s ease;
    }

    .date-input-container:focus-within {
        border-color: #2563eb;
        box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
    }

    .date-nav-btn {
        width: 36px;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: none;
        background: rgba(37, 99, 235, 0.08);
        color: #2563eb;
        border-radius: 8px;
        cursor: pointer;
        transition: all 0.2s ease;
        flex-shrink: 0;
    }

    .date-nav-btn:hover {
        background: rgba(37, 99, 235, 0.15);
        transform: scale(1.05);
    }

    .date-nav-btn:active {
        transform: scale(0.95);
    }

    .date-nav-btn svg {
        width: 14px;
        height: 14px;
    }

    .date-picker-modern {
        flex: 1;
        min-width: 0;
    }

    .date-picker-modern :deep(.mx-input-wrapper) {
        border: none;
        background: transparent;
    }

    .date-picker-modern :deep(.mx-input) {
        border: none;
        background: transparent;
        padding: 0.5rem 0.75rem;
        font-size: 0.95rem;
        font-weight: 500;
        color: #1e293b;
        border-radius: 8px;
        width: 100%;
    }

    .date-picker-modern :deep(.mx-input:focus) {
        outline: none;
        background: rgba(37, 99, 235, 0.05);
    }

    .date-separator {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0.5rem 0;
        color: #94a3b8;
        flex-shrink: 0;
        align-self: flex-end;
        margin-bottom: 0.5rem;
    }

    .date-separator svg {
        width: 20px;
        height: 20px;
    }

    .btn-filter-modern {
        display: inline-flex;
        align-items: center;
        gap: 0.5rem;
        padding: 0.75rem 1.75rem;
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
        color: #ffffff;
        border: none;
        border-radius: 12px;
        font-weight: 600;
        font-size: 0.95rem;
        cursor: pointer;
        transition: all 0.2s ease;
        box-shadow: 0 4px 12px rgba(37, 99, 235, 0.25);
        white-space: nowrap;
        height: fit-content;
    }

    .btn-filter-modern:hover {
        background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);
        transform: translateY(-2px);
        box-shadow: 0 6px 16px rgba(37, 99, 235, 0.35);
    }

    .btn-filter-modern:active {
        transform: translateY(0);
    }

    .btn-filter-modern svg {
        width: 18px;
        height: 18px;
        flex-shrink: 0;
    }

    /* Suporte para tema escuro - Card de filtragem */
    [data-bs-theme="dark"] .filter-card {
        background: linear-gradient(135deg, rgba(15, 23, 42, 0.95) 0%, rgba(30, 41, 59, 0.9) 100%);
    }

    [data-bs-theme="dark"] .filter-header {
        border-bottom-color: rgba(59, 130, 246, 0.2);
    }

    [data-bs-theme="dark"] .filter-icon {
        color: #60a5fa;
    }

    [data-bs-theme="dark"] .filter-title {
        color: #f1f5f9;
    }

    [data-bs-theme="dark"] .date-label {
        color: #cbd5e1;
    }

    [data-bs-theme="dark"] .date-input-container {
        background: rgba(15, 23, 42, 0.8);
        border-color: rgba(59, 130, 246, 0.3);
    }

    [data-bs-theme="dark"] .date-input-container:focus-within {
        border-color: #60a5fa;
        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
    }

    [data-bs-theme="dark"] .date-nav-btn {
        background: rgba(59, 130, 246, 0.15);
        color: #60a5fa;
    }

    [data-bs-theme="dark"] .date-nav-btn:hover {
        background: rgba(59, 130, 246, 0.25);
    }

    [data-bs-theme="dark"] .date-picker-modern :deep(.mx-input) {
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .date-picker-modern :deep(.mx-input:focus) {
        background: rgba(59, 130, 246, 0.1);
    }

    [data-bs-theme="dark"] .date-separator {
        color: #64748b;
    }

    [data-bs-theme="dark"] .btn-filter-modern {
        background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);
        box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
    }

    [data-bs-theme="dark"] .btn-filter-modern:hover {
        background: linear-gradient(135deg, #1e40af 0%, #1e3a8a 100%);
        box-shadow: 0 6px 16px rgba(59, 130, 246, 0.4);
    }

    /* Responsividade */
    @media (max-width: 768px) {
        .filter-content {
            flex-direction: column;
        }

        .date-range-wrapper {
            flex-direction: column;
            width: 100%;
        }

        .date-input-group {
            width: 100%;
        }

        .date-separator {
            transform: rotate(90deg);
            margin: 0.5rem 0;
        }

        .btn-filter-modern {
            width: 100%;
            justify-content: center;
        }
    }
</style>

